'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('text-list', {
      url: '/text/:type/list',
      params:{type:null},
      template: '<text-list></text-list>',
      authenticate: 'suite-user'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/text/list/text-list.routes.js